import { Aluno } from './aluno';
import { AtividadeAluno } from './atividade-aluno';
import { Unidade } from './unidade';

export class UniformeAluno {
	id: number;
	dataUniformeEntregue: Date;
	nomeUniforme: string;
	tamanhoUniforme: string;
	qtdUniformeEntregue: number;
	atividadesAluno: AtividadeAluno;
	usuarioAlteracao: number;

	disabilitado: boolean;

	aluno: Aluno;
	unidade: Unidade;
}